<div class="settings-container">
  <div class="setting-header">
    <div class="title">Settings</div>
    <img src="../../../../assets/icons/cross.svg" (click)="onCrossClick()" alt="cross-icon">
  </div>
  <div class="setting-body">
    <div class="tab-selection">
      <mat-tab-group animationDuration="0ms" (selectedTabChange)="onTabChange($event)" class="vertical-tabs">
        <mat-tab>
          <ng-template class="tab-content" mat-tab-label>
            <img src="../../../../assets/icons/general.svg" alt="general">
            General
          </ng-template>
        </mat-tab>
        <!-- NOT NEEDED FOR PHASE 1 -->
        <!-- <mat-tab>
                  <ng-template class="tab-content" mat-tab-label>
                    <img src="../../../../assets/icons/collaborators.svg" alt="collaborators">
                    Collaborators
                  </ng-template>
                </mat-tab>

                <mat-tab>
                  <ng-template class="tab-content" mat-tab-label>
                    <img src="../../../../assets/icons/version_history.svg" alt="version_history">
                    Version History
                  </ng-template>
                </mat-tab> -->
      </mat-tab-group>
    </div>

    <div class="selected-area">
      <ng-container *ngIf="selectedTabIndex === 0">
        <app-general-settings></app-general-settings>
      </ng-container>
      <ng-container *ngIf="selectedTabIndex === 1">
        <app-collaborators-settings></app-collaborators-settings>
      </ng-container>
      <ng-container *ngIf="selectedTabIndex === 2">
        <app-version-history-settings></app-version-history-settings>
      </ng-container>
    </div>
  </div>
</div>
